import * as actionTypes from '../actions/actionTypes';

export const documentInitialState = {
  document: [],
  loading: false,
  loaded: false,
  error: null
};
const reducer = (state = documentInitialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DOCUMENT_DATA_START:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_DOCUMENT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        document: action.data.documentsList
      };
    case actionTypes.GET_DOCUMENT_DATA_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
